module.exports = __webpack_public_path__ + "static/media/sword-laser.26f74611.svg";